import React, { useState } from 'react';

const Newsletter = () => {
    const [email, setEmail] = useState('');

    const handleSubscribe = (e) => {
        e.preventDefault();
        // This is where you will eventually call your Node.js API
        console.log("Subscribing with email:", email);
        alert("Thank you for subscribing!");
        setEmail('');
    };

    return (
        <section className="newsletter text-white z-1 position-relative">
            <div className="container">
                <div className="newsletter-inner p-6 bg-green1 rounded2 text-center text-md-start">
                    <div className="row gx-xl-5 gy-4 align-items-center">
                        <div className="col-xl-5">
                            <div className="section-title">
                                <h6 className="text-uppercase fw-medium mb-1 text-white">Subscribe Newsletter</h6>
                                <h3 className="text-white">Don't miss our future updates! Get subscribed today!</h3>
                            </div>
                        </div>
                        <div className="col-xl-7">
                            <div className="section-body">
                                <p className="mb-3">
                                   "Stay charged with the latest insights in sustainable energy and EV solutions.Join our community for exclusive updates on the future of green infrastructure."
                                </p>
                                <form onSubmit={handleSubscribe} className="search-bar d-md-flex">
                                    <input
                                        type="email"
                                        placeholder="Enter your email..."
                                        className="w-100 mx-1"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        required
                                    />
                                    <button type="submit" className=" border-0 btn3 mx-1">
                                        subscribe
                                    </button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Newsletter;